import { getBillLibraryChapterTree, getBillLibraryList } from "@/api/baseInventory"
import { getGovermentTemplateItemList, getGovernmentTemplateLibList, getTemplateDetail, getTemplateRelationList } from "@/api/governmentTemplate"
import useMemoizedFns from "@/hooks/useMemoizedFns"
import { arrayToTree, traverseTree } from "@/utils/tree"
import useStore, { DocumentSettingProjectData } from "@/pages/documentCompile/store/useStore"
import { DocumentSettingType, FieldType } from "../../type"
import { getDictTableData } from "../../dict/utils"
import { DictTemplateCodeEnum } from "../../dict/type"
import { getDomainTableData } from "../../domain/utils"
import { filterListFieldByDoc, getAntdFormDataByRes, getDomainTreeDataByDict, getTemplateDomainTreeData } from "../utils/dataTransform"
import { getProjectAttrs, getProjectFields, getUserSignImage } from "../../api/data-project"
import { getViewByProjectId, getViewsFolderByViewId } from "@/pages/documentCompile/api/data-project-view"
import dayjs from "dayjs"
import { isTimestamp } from "@/utils/tools"
import { getMemberInfoList } from "../../api/memberInfo"
import { getEnterpriseInfoList } from "../../api/enterpriseInfo"
import { transformBaseInfoTableData } from "../../baseInfo/util"
import { useSearchParams } from "react-router-dom"
import { listFieldByDoc } from "../../api/data-project-doc"
import { useQueries, useQueryClient } from '@tanstack/react-query'
import { isLegalPreviewFileType } from "../../utils/file"
import { getPackFolderTreeDataByRes } from "../utils/field"
import { message } from "antd"

export default function useInitData() {
    const [searchParams] = useSearchParams();
    const setState = useStore.setState
    const queryClient = useQueryClient()

    const initDomainSettingData = async (open: boolean, isInit = false) => {
        const documnetSettingType = useStore.getState().documnetSettingType
        const settingData = useStore.getState().documentSettingProjectData
        const folderList = useStore.getState().folderList
        const needLoadDomainConfig = useStore.getState().needLoadDomainConfig
        // 如果不需要加载域配置，则不执行初始化
        // if (!needLoadDomainConfig) return;
        let domainTreeData = [] as any[]
        let expandedKeysData = [] as any[]
        const docUrl = settingData?.documentDetail?.docUrl || settingData?.documentDetail?.documentUrl
        // console.log("initDomainSettingData", {
        //     name: settingData?.documentDetail?.name,
        //     docUrl: docUrl,
        // })

        // console.log("docUrl", docUrl)
        // 文档模板
        if (documnetSettingType === DocumentSettingType.DOCUMENT_TEMPLATE) {
            const [rootNode, expandedKeys] = await queryClient.fetchQuery({
                queryKey: ['templateDomainTreeData', open],
                queryFn: () => getTemplateDomainTreeData(),
                staleTime: Infinity,
            })
            domainTreeData = rootNode
            expandedKeysData = expandedKeys
        }

        // 资料包
        if (documnetSettingType === DocumentSettingType.DATA_PROJECT_FILE) {
            console.log("settingData", settingData);

            // const promiseList = [
            //     getProjectAttrs(settingData?.projectId),
            //     getViewsFolderByViewId(settingData?.projectId, settingData?.viewId),
            //     getDictTableData(DictTemplateCodeEnum.PROJECT_ATTR),
            //     getProjectFields(settingData?.projectId),
            //     getDomainTableData(),
            //     getMemberInfoList({
            //         pageIndex: 1,
            //         pageSize: 1000,
            //     }),
            //     getEnterpriseInfoList({
            //         pageIndex: 1,
            //         pageSize: 1000,
            //     }),
            //     listFieldByDoc({
            //         projectId: settingData?.projectId,
            //         docId: settingData?.documentDetail?.id,
            //     }),
            // ]


            const results = await Promise.all([
                queryClient.fetchQuery({
                    queryKey: ['projectAttrs', docUrl, settingData?.projectId, open],
                    queryFn: () => getProjectAttrs(settingData?.projectId),
                    staleTime: Infinity,
                }),
                queryClient.fetchQuery({
                    queryKey: ['viewsFolderByViewId', docUrl, settingData?.projectId, settingData?.viewId, open],
                    queryFn: () => getViewsFolderByViewId(settingData?.projectId, settingData?.viewId),
                    staleTime: Infinity,
                }),
                queryClient.fetchQuery({
                    queryKey: ['dictTableData', DictTemplateCodeEnum.PROJECT_ATTR, open],
                    queryFn: () => getDictTableData(DictTemplateCodeEnum.PROJECT_ATTR),
                    staleTime: Infinity,
                }),
                queryClient.fetchQuery({
                    queryKey: ['projectFields', docUrl, settingData?.projectId, open],
                    queryFn: () => getProjectFields(settingData?.projectId),
                    staleTime: Infinity,
                }),
                queryClient.fetchQuery({
                    queryKey: ['domainTableData', open],
                    queryFn: () => getDomainTableData(),
                    staleTime: Infinity,
                }),
                queryClient.fetchQuery({
                    queryKey: ['memberInfoList', open],
                    queryFn: () => getMemberInfoList({
                        pageIndex: 1,
                        pageSize: 1000,
                    }),
                    staleTime: Infinity,
                }),
                queryClient.fetchQuery({
                    queryKey: ['enterpriseInfoList', open],
                    queryFn: () => getEnterpriseInfoList({
                        pageIndex: 1,
                        pageSize: 1000,
                    }),
                    staleTime: Infinity,
                }),
                queryClient.fetchQuery({
                    queryKey: ['listFieldByDoc', docUrl, settingData?.projectId, settingData?.documentDetail?.id, open],
                    queryFn: () => listFieldByDoc({
                        projectId: settingData?.projectId,
                        docId: settingData?.documentDetail?.id,
                    }),
                    staleTime: Infinity,
                }),
                getUserSignImage()
            ]);

            const [
                projectAttrRes,
                viewRes,
                dictProjectRes,
                projectDomainFields,
                domainData,
                personBaseInfoDataRes,
                enterpriseBaseInfoDataRes,
                usedDomainRes,
                signImageRes
            ] = results;
            const newUsedDomainRes = getAntdFormDataByRes(usedDomainRes)
            // console.log("viewRes", docUrl, viewRes)
            const newViewRes = viewRes.map(item => {
                return {
                    ...item,
                    viewId: settingData?.viewId,
                }
            })
            setState({ needLoadDomainConfig: false })
            console.log("newViewRes", newViewRes)

            if (signImageRes) {
                setState({
                    signImageRes
                })
            }

            const projectInfoDictCodeMap = {} as any
            (dictProjectRes as any[]).forEach(item => {
                projectInfoDictCodeMap[item.dictCode] = item;
            })
            const usedDomainDocDataMap = {} as any
            (newUsedDomainRes as any[]).forEach(item => {
                usedDomainDocDataMap[item.fieldTag] = item;
            })

            // const [rootNode, expandedKeys] = await queryClient.fetchQuery({
            //     queryKey: ['domainTreeDataByDict', domainData, dictProjectRes, open],
            //     queryFn: () => getDomainTreeDataByDict(domainData, dictProjectRes),
            //     staleTime: Infinity,
            // })
            const [rootNode, expandedKeys] = getDomainTreeDataByDict(domainData, dictProjectRes)

            domainTreeData = rootNode
            expandedKeysData = expandedKeys

            const allDomainTagMap = {} as any
            traverseTree(domainTreeData, (node) => {
                if (node.fieldTag) {
                    allDomainTagMap[node.fieldTag] = node;
                }
            })

            let settingProjectFormData = {}
            projectAttrRes.forEach(item => {
                if (isTimestamp(item.value)) {
                    settingProjectFormData[item.name] = dayjs(Number(item.value))
                } else {
                    settingProjectFormData[item.name] = item.value
                }
            })


            let settingDomainFormData = {};
            const newProjectDomainFields = getAntdFormDataByRes(projectDomainFields);
            (newProjectDomainFields as any[])?.forEach(item => {
                if (isTimestamp(item.fieldValue)) {
                    settingDomainFormData[item.fieldTag] = dayjs(Number(item.fieldValue))
                } else {
                    settingDomainFormData[item.fieldTag] = item.fieldValue
                }
            })
            if (isInit) {
                setState({
                    settingDomainFormData
                })
            }
            setState({
                usedDomainDocDataMap,
                projectInfoDictData: dictProjectRes,
                projectInfoDictCodeMap,
                projectInfoAttrValues: projectAttrRes,
                allDomainTagMap,
                settingProjectFormData,
                personBaseInfoData: transformBaseInfoTableData(personBaseInfoDataRes?.result),
                enterpriseBaseInfoData: transformBaseInfoTableData(enterpriseBaseInfoDataRes?.result),
            });
            (newViewRes as any[]).forEach(item => {
                item.rid = item.id;
                if (!item.folder) {
                    item.rid = `${item.id}${item.parentId}`;
                }
            })
            const { tree: packageFolderTreeData, expandKey: packageFolderTreeDataExpandedKeys } = getPackFolderTreeDataByRes(newViewRes, folderList)
            setState({
                packageFolderTreeData: packageFolderTreeData,
                packageFolderTreeDataExpandedKeys: packageFolderTreeDataExpandedKeys as any[]
            })
        }
        setState({
            domainTreeData: domainTreeData,
            domainTreeDataExpandedKeys: expandedKeysData
        })
    };

    // 刷新 folderList 和 currentDetailFolder  catalogDocUrl
    const refreshJuanInfo = async () => {
        const projectId = searchParams.get('projectId');
        const currentSettingDetailFolderDoc = useStore.getState().currentSettingDetailFolderDoc
        const currentDetailFolder = useStore.getState().currentDetailFolder
        const folderList = useStore.getState().folderList
        const viewInfo = await getViewByProjectId(projectId)
        const newRsutl = (folderList as any[]).map(i => {
            const trueViewInfo = (viewInfo as any[]).find(j => j.id === i.viewId)
            return {
                ...i,
                catalogDocUrl: trueViewInfo?.catalogDocUrl
            }
        })
        const newCurrentSettingDetailFolderDoc = newRsutl.find(i => i.viewId === currentSettingDetailFolderDoc?.viewId)
        const newCurrentDetailFolder = newRsutl.find(i => i.viewId === currentDetailFolder?.viewId)
        //  更新 currentDetailFolder ， 
        console.log("dddd", currentDetailFolder, folderList)
        setState({
            folderList: newRsutl,
            currentSettingDetailFolderDoc: newCurrentSettingDetailFolderDoc,
            currentDetailFolder: newCurrentDetailFolder
        })
    }

    const refreshPackageFolderTreeData = async (providedViewRes?: any[]) => {
        const projectId = searchParams.get('projectId');
        // 这里的 folderList 需要重新调用接口刷新
        // const folderList = await getViewsFolder(projectId)
        // if(latestEditorConfig.document.documentType === editorConfig.document.documentType){

        // }
        await refreshJuanInfo()
        const folderList = useStore.getState().folderList
        const currentSettingDetailFolderDoc = useStore.getState().currentSettingDetailFolderDoc
        // console.log("currentSettingDetailFolderDoc", currentSettingDetailFolderDoc)
        const currentDetailFolder = useStore.getState().currentDetailFolder
        const viewId = currentSettingDetailFolderDoc?.viewId || currentDetailFolder?.viewId
        if (!viewId) {
            message.error("找不到 viewId")
        }
        const documnetSettingType = useStore.getState().documnetSettingType
        const settingData = useStore.getState().documentSettingProjectData
        if (documnetSettingType === DocumentSettingType.DOCUMENT_TEMPLATE) {
            return;
        }
        // 如果已提供viewRes，则不需要重复调用 getViewsFolderByViewId 接口
        let viewRes = providedViewRes;
        const promiseList = [];
        if (!providedViewRes) {
            promiseList.push(getViewsFolderByViewId(projectId, viewId));
        }
        let fnListFieldByDoc = Promise.resolve([])
        if (settingData?.documentDetail?.isJuan) {
            fnListFieldByDoc = Promise.resolve([])
        } else {
            fnListFieldByDoc = listFieldByDoc({
                projectId: settingData?.projectId,
                docId: settingData?.documentDetail?.id,
            })
        }
        promiseList.push(fnListFieldByDoc);

        const results = await Promise.all(promiseList);
        // 根据是否提供了viewRes来解构结果
        let usedDomainRes;
        if (!providedViewRes) {
            [viewRes, usedDomainRes] = results;
        } else {
            [usedDomainRes] = results;
        }
        const newUsedDomainRes = filterListFieldByDoc(usedDomainRes)

        const newViewRes = viewRes.map(item => {
            return {
                ...item,
                viewId: viewId,
            }
        })
        const usedDomainDocDataMap = {} as any
        (newUsedDomainRes as any[]).forEach(item => {
            usedDomainDocDataMap[item.fieldTag] = item;
        })
        const { tree: packageFolderTreeData, expandKey: packageFolderTreeDataExpandedKeys } = getPackFolderTreeDataByRes(newViewRes, folderList)
        setState({
            usedDomainDocDataMap,
            packageFolderTreeData: packageFolderTreeData,
            packageFolderTreeDataExpandedKeys: packageFolderTreeDataExpandedKeys as any[]
        })
    }



    return useMemoizedFns({
        initDomainSettingData,
        refreshPackageFolderTreeData,
    })
}
